import { useState } from "react";
import { usePassportStore, useRootStore } from "../../../../../stores";
import { useBreakpoint } from "../../../../../hooks";
import { ResultData } from "../Result.modal";
import {
  LivenessErrorCode,
  LivenessLocale,
  LivenessResult,
  LIvenessStatus,
} from "../../../../../constants";

const GENERAL_ERROR = {
  status: LIvenessStatus.Error,
  result: LivenessResult.Invalid,
  errorCode: LivenessErrorCode.GeneralError,
};

type Props = {
  setResult: (result: ResultData | null) => void;
  setShowResultModal: (show: boolean) => void;
};

export const useInitOneKycProcess = ({
  setResult,
  setShowResultModal,
}: Props) => {
  const [showInitModal, setShowInitModal] = useState<boolean>(false);
  const [launchUrl, setLaunchUrl] = useState<string | null>(null);
  const [qrLaunchUrl, setQrLaunchUrl] = useState<string | null>(null);
  const [showConfirmCloseModal, setShowConfirmCloseModal] = useState<boolean>(
    false
  );

  const store = usePassportStore();
  const { isMobile } = useBreakpoint();
  const {
    $translationStore: { language$ },
  } = useRootStore();

  const resetState = () => {
    setLaunchUrl(null);
    setQrLaunchUrl(null);
    setShowInitModal(false);
  };

  // init liveness
  const handleStart = () => {
    // resetting previous state
    setResult(null);
    setShowInitModal(true);
  };
  const handleCloseInitModal = () => setShowInitModal(false);

  // choose camera or qr
  const handleCamera = async () => {
    resetState();

    try {
      const url = await store.createLivenessUrl(
        false,
        isMobile,
        LivenessLocale[language$]
      );
      setLaunchUrl(url);
    } catch (e) {
      setResult(GENERAL_ERROR);
      setShowResultModal(true);
    }
  };
  const handleQR = async () => {
    resetState();

    try {
      const url = await store.createLivenessUrl(
        true,
        false,
        LivenessLocale[language$]
      );
      setQrLaunchUrl(url);
    } catch (e) {
      setResult(GENERAL_ERROR);
      setShowResultModal(true);
    }
  };

  // cancelling during camera/qr process
  const handleConfirmCloseModal = () => setShowConfirmCloseModal(true);
  const handleCloseConfirmModal = () => setShowConfirmCloseModal(false);
  const handleOnConfirmedClose = () => {
    resetState();
    setShowConfirmCloseModal(false);
  };

  return {
    showInitModal,
    showConfirmCloseModal,
    launchUrl,
    qrLaunchUrl,
    handleStart,
    handleCloseInitModal,
    handleCamera,
    handleQR,
    handleConfirmCloseModal,
    handleCloseConfirmModal,
    handleOnConfirmedClose,
    resetState,
  };
};
